import LemonError from '@src/service/common/LemonError';

export default class MissingLocaleException extends LemonError {
  constructor(locale: string) {
    super(`Locale is missing "${locale}"`);
  }
}
